import React, { lazy } from 'react';
import { AuthGuard } from '@nsd/fe';
import { Trello as ClaimsIcon } from 'react-feather';
import appIcon from './images/appIcon.png';
import TopBarAddOn from 'src/components/TopBarAddOn';
import DashboardLayout from 'src/layouts/DashboardLayout';

const MODULE = {
    GLASS_CLAIMS: 'glassclaims-e57cea6c-009c-4a81-ac74-c3a703be59de'
};

const appConfig = {
    appId: 'glass-fb0d0cc5-b980-4102-9b3c-ab35df33d5c0',
    appName: 'Glass',
    titleKey: 'glass',
    priority: 2,
    path: 'glass',
    icon: appIcon,
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
        {
            exact: true,
            path: 'browse-claim',
            view: lazy(() => import('src/views/ExternalClaims/BrowseClaimView'))
        },
        {
            exact: true,
            path: 'glass/claim',
            view: lazy(() => import('src/views/ExternalClaims/ExternalClaimsView'))
        },
        {
            exact: true,
            path: 'glass',
            redirect: 'browse-claim'
        },
    ],

    topBarConfig: {
        dataContextOptions: {
            enableDataContextOverride: true,
            customJSX: <TopBarAddOn />
        },
        contacts: false,
        search: false,
        notifications: true,
        settings: true,
        onDataContextChange: args => {
            console.log(args);
        }
    },
    navConfig: {
        navBarItems: [
            {
                subheader: 'Glass Claims',
                items: [
                    {
                        title: 'Claims',
                        href: 'browse-claim',
                        icon: ClaimsIcon,
                        module: MODULE.GLASS_CLAIMS
                    }
                ]
            },
        ]
    }
};

export default appConfig;
